import { gql } from 'apollo-angular';

export const GET_SUPPLIERS = gql`
  query suppliers($search: String) {
    suppliers(search: $search) {
      id
      supplierName
      supplierCode
      address
      contact
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const FETCH_SUPPLIER_BY_ID = gql`
  query supplier($id: Int!) {
    supplier(id: $id) {
    id
    supplierName
    supplierCode
    address
    contact
    status
    createdAt
    updatedAt
    deletedAt
    }
  }
`;


export const GET_SUPPLIER_CODE = gql`
  query {
    generateSupplierCode
  }
`;